import { Component, Input } from '@angular/core';
import { ControlBase } from '../../base/control-base/control-base.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { ControlContainer, FormGroupDirective } from '@angular/forms';

@Component({
    selector: 'hidden-extended-control',
    templateUrl: 'hidden-extended.control.html',
    standalone: false,
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class HiddenExtendedControl extends ControlBase {
    constructor(protected override spinnerService: NgxSpinnerService) {
        super(spinnerService);
    }

    @Input() controlName!: string;
    @Input() inputId: string = '';

    @Input() parentFormHelper!: {
        showFieldError(controlName: string): boolean;
        getErrorMessageHtml(controlName: string): string;
    };
}
